import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useQueryGamesByIds } from './useQueryGames';
import { useRecentGames } from '../useRecentGames';
import {
  recentLaunchedGamesSelector,
  recentSearchedGamesSelector,
} from '../../redux/reducers/app/storage';

const gameIdValidator = (id) => typeof id === 'string';

export const useQueryRecentLaunchedGames = (queryOptions = {}) => {
  const games = useSelector(recentLaunchedGamesSelector);
  const ids = games?.map((game) => game.id)?.filter(gameIdValidator);

  const select = (data) => {
    return data?.items?.filter((game) => game?.status === 'ACTIVE') || [];
  };

  return useQueryGamesByIds(ids, { select, ...queryOptions });
};

export const useQueryRecentSearchedGames = (queryOptions = {}) => {
  const games = useSelector(recentSearchedGamesSelector);
  const ids = games?.map((game) => game?.id)?.filter(gameIdValidator);

  const select = (data) =>
    data?.items?.filter((game) => game?.status === 'ACTIVE') || [];

  return useQueryGamesByIds(ids, { select, ...queryOptions });
};

export const useQueryRecentGame = (queryOptions = {}) => {
  const queryRecentLaunchedGames = useRecentGames(queryOptions);
  const recentGame = useMemo(
    () => queryRecentLaunchedGames?.data?.[0] ?? null,
    [queryRecentLaunchedGames]
  );

  return useMemo(
    () => ({
      ...queryRecentLaunchedGames,
      data: recentGame,
    }),
    [queryRecentLaunchedGames, recentGame]
  );
};
